<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.SearchJobNo')"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
      class="app-main-inner edi-bill-search-selector"
      @close="cancel()"
    >
      <div class="app-main-inner-row">
        <el-form label-width="60px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
                <el-input v-model="elForm.jobNo" no="1" style="width: 260px;" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_ChineseFirstVesselName')">
                <cargo-advance-select
                  no="2"
                  filterable
                  style="width: 260px;"
                  :select-type="selectTypeNames.basic_data_Vessel"
                  allow-create
                  callback-method-type="value"
                  :default-value="elForm.vessel||''"
                  :callback-params="{key:'vessel'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_VoyageNo')">
                <el-input v-model="elForm.voyageFlight" no="3" style="width: 260px;" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_PortOfDischarge')">
                <cargo-advance-select
                  no="4"
                  filterable
                  style="width: 260px;"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  callback-method-type="value"
                  :default-value="elForm.dischargingPortCode||''"
                  :callback-params="{key:'dischargingPortCode'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
                <cargo-advance-select
                  no="5"
                  filterable
                  style="width: 260px;"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{customer:true,companyLob:'seaExport',active:true}"
                  callback-method-type="value"
                  :default-value="elForm.customerId||''"
                  :callback-params="{key:'customerId'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_CarrierShip')">
                <cargo-advance-select
                  no="6"
                  filterable
                  style="width: 260px;"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                  callback-method-type="value"
                  :default-value="elForm.carrierId||''"
                  :callback-params="{key:'carrierId'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_SailingDate')">
                <div style="display: flex;justify-content: space-between; width: 260px;">
                  <el-date-picker
                    v-model="elForm.dfETD1"
                    no="7"
                    type="date"
                    style="width:125px;"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="font-size: 12px;margin-left: 1px;margin-right: 1px;">-</span>
                  <el-date-picker
                    v-model="elForm.dfETD2"
                    no="8"
                    type="date"
                    style="width:125px;"
                    clearable
                    value-format="yyyy-MM-dd"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="MBL NO">
                <el-input v-model="elForm.mbl" no="9" style="width: 260px;" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="0">
                <el-checkbox v-model="elForm.notEqPAgentAndFAgent" no="15"> {{ $t('SeaExport.DestinationPortAgentIsNotEqualToDesignatedFreightAgent') }} </el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="SONO">
                <el-input v-model="elForm.soNo" no="10" style="width: 260px;" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item>
                <el-button no="11" style="margin-left: -60px;" type="primary" @click="searchHandler">{{ $t('common.btn.query') }}</el-button>
                <el-button no="12" type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
        <cargo-ag-grid
          v-if="params.selectType === 'multiple'&&innerVisible"
          config-module="130200"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefsMultiple"
          :row-data="rowData"
          style="width:100%;height:350px;"
          @gridReady="params=>gridApi=params.api"
        />
        <cargo-ag-grid
          v-if="params.selectType === 'single'&&innerVisible"
          config-module="130201"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefsSingle"
          :row-data="rowData"
          style="width:100%;height:350px;"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div class="app-main-inner-row row-pagination">
        <cargo-pagination
          v-show="searchConditions.total>0"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="searchHandler"
        />
      </div>
      <div slot="footer">
        <el-button no="13" type="primary" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="14" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getGridSelected } from '@/utils/agGrid'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { getLoading } from '@/utils/utilBaseElement'
import { searchMscDataFunc } from '@/api/seaExport/mscSupplement'

export default {
  name: 'MscSearchDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, default: 'SE' },
    params: {
      type: Object,
      default: () => {
        return {
          selectType: 'single',
          job: {},
          useDefaultCondition: false,
          excludeUuids: []
        }
      },
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      elForm: {
        jobNo: '',
        vessel: '',
        voyageFlight: '',
        mbl: '',
        dischargingPortCode: '',
        customerId: '',
        carrierId: '',
        dfETD1: null,
        dfETD2: null,
        soNo: '',
        notEqPAgentAndFAgent: false // 目的港代理不等于指定货代理
      },
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      rowData: [],
      columnDefsSingle: [
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 200 },
        { headerName: this.$t('SeaExport.ShipperId'), field: 'shipperCode', width: 200 },
        {
          headerName: this.$t('SeaExport.ShipperInfo'),
          field: 'shipperLine',
          width: 200,
          tooltip: params => params.value
        },
        { headerName: this.$t('SeaExport.ConsigneeId'), field: 'consigneeCode', width: 200 },
        {
          headerName: this.$t('SeaExport.ConsigneeInfo'),
          field: 'consigneeLine',
          width: 200,
          tooltip: params => params.value
        },
        { headerName: this.$t('SeaExport.NotifyId'), field: 'notifyCode', width: 200 },
        {
          headerName: this.$t('SeaExport.NotifyInfo'),
          field: 'notifyLine',
          width: 200,
          tooltip: params => params.value
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentCode'), field: 'paymentCode', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentInfo'),
          field: 'paymentLine',
          width: 200,
          tooltip: params => params.value
        }
      ],
      columnDefsMultiple: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 200 },
        { headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('SeaExport.MblNo2'), field: 'mbl', width: 200 },
        { headerName: this.$t('SeaExport.Quantity'), field: 'quantityActual', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          } },
        { headerName: this.$t('SeaExport.Weight'), field: 'weightActual', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } },
        { headerName: this.$t('SeaExport.Cubage'), field: 'cubageActual', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        }
      ],
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false
      }
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    init() {
      if (this.params && this.params.job) {
        this.elForm.dischargingPortCode = this.params.job.dischargingPortCode
        this.elForm.dfETD1 = this.params.job.etd
        this.elForm.dfETD2 = this.params.job.etd
        this.elForm.vessel = this.params.job.vessel
        this.elForm.voyageFlight = this.params.job.voyageFlight
        this.elForm.notEqPAgentAndFAgent = false
      }
    },
    getValueFromChild(obj) {
      this.elForm[obj.key] = obj.value
    },
    searchHandler() {
      this.gridApi.clearFocusedCell() // 清除选中行
      this.loading = getLoading()
      const startTime = new Date().getTime()
      const elForm = this.elForm
      const docType = this.params.docType
      const params = {}
      params.docType = docType
      params.branchId = this.$store.getters.currentOfficeId
      params.pageNum = this.searchConditions.pageNum
      params.pageSize = this.searchConditions.pageSize
      if (elForm.jobNo && elForm.jobNo.trim().length > 0) {
        params.jobNo = elForm.jobNo.trim()
      }
      if (elForm.mbl && elForm.mbl.trim().length > 0) {
        params.mbl = elForm.mbl.trim()
      }
      if (elForm.soNo && elForm.soNo.trim().length > 0) {
        params.soNo = elForm.soNo.trim()
      }
      if (elForm.vessel && elForm.vessel.trim().length > 0) {
        params.vessel = elForm.vessel.trim()
      }
      if (elForm.voyageFlight && elForm.voyageFlight.trim().length > 0) {
        params.voyageFlight = elForm.voyageFlight.trim()
      }
      if (elForm.customerId) {
        params.customerId = elForm.customerId
      }
      if (elForm.carrierId) {
        params.carrierId = elForm.carrierId
      }
      if (elForm.dischargingPortCode && elForm.dischargingPortCode.trim().length > 0) {
        params.dischargingPortCode = elForm.dischargingPortCode.trim()
      }
      if (elForm.dfETD1) {
        params.etdStart = elForm.dfETD1
      }
      if (elForm.dfETD2) {
        params.etdEnd = elForm.dfETD2
      }
      params.notEqPAgentAndFAgent = elForm.notEqPAgentAndFAgent
      searchMscDataFunc(params).then(result => {
        this.rowData = result.data.list
        for (const item of this.rowData) {
          let shipperLine = ''
          let consigneeLine = ''
          let notifyLine = ''
          let paymentLine = ''
          shipperLine += (item['shipperVipCode'] || '') + '\n' + (item['shipperMscCode'] || '') +
            '\n' + (item['shipperCompanyCode'] || '') + '\n' + (item['shipperInttraCode'] || '') +
            '\n' + (item['shipperBlCompany'] || '') + '\n' + (item['shipperBlAddress'] || '') + '\n' + (item['shipperBlContact'] || '')
          consigneeLine += (item['consigneeVipCode'] || '') + '\n' + (item['consigneeMscCode'] || '') +
            '\n' + (item['consigneeCompanyCode'] || '') + '\n' + (item['consigneeInttraCode'] || '') +
            '\n' + (item['consigneeBlCompany'] || '') + '\n' + (item['consigneeBlAddress'] || '') + '\n' + (item['consigneeBlContact'] || '')
          notifyLine += (item['notifyVipCode'] || '') + '\n' + (item['notifyMscCode'] || '') +
            '\n' + (item['notifyCompanyCode'] || '') + '\n' + (item['notifyInttraCode'] || '') +
            '\n' + (item['notifyBlCompany'] || '') + '\n' + (item['notifyBlAddress'] || '') + '\n' + (item['notifyBlContact'] || '')
          paymentLine += (item['paymentVipCode'] || '') + '\n' + (item['paymentMscCode'] || '') +
            '\n' + (item['paymentCompanyCode'] || '') + '\n' + (item['paymentInttraCode'] || '') +
            '\n' + (item['paymentBlCompany'] || '') + '\n' + (item['paymentBlAddress'] || '') + '\n' + (item['paymentBlContact'] || '')
          item.shipperLine = shipperLine
          item.consigneeLine = consigneeLine
          item.notifyLine = notifyLine
          item.paymentLine = paymentLine
        }
        this.searchConditions.total = parseInt(result.data.total)
      }).catch(message => {
        this.$message.error(message)
      }).finally(() => {
        const delayMs = new Date().getTime() - startTime < 1000 ? 500 : 0
        setTimeout(() => {
          this.loading.close()
        }, delayMs)
      })
    },
    reset() {
      const elForm = this.elForm
      elForm.jobNo = ''
      elForm.vessel = ''
      elForm.voyageFlight = ''
      elForm.mbl = ''
      elForm.dischargingPortCode = ''
      elForm.customerId = ''
      elForm.carrierId = ''
      elForm.soNo = ''
      elForm.dfETD1 = null
      elForm.dfETD2 = null
      elForm.notEqPAgentAndFAgent = false
    },
    confirm() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (this.params.selectType === 'multiple') {
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectTheListToBeMergedInto'))
          return
        }
        this.$emit('selected', chooseRows)
      } else {
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('SeaExport.SelectARecord'))
          return
        }
        this.$emit('selected', chooseRows[0])
      }
      this.innerVisible = false
    },
    cancel() {
      this.innerVisible = false
      this.rowData = []
      this.reset()
    },
    fillModel() {
      let defaultConditionByDocType = true
      const docType = this.params.docType
      const job = this.params.job
      const elForm = this.elForm
      if (docType === CargoDocConsts.MBL2 || docType === CargoDocConsts.HBL2 || docType === CargoDocConsts.HAWB2) {
        defaultConditionByDocType = false
      }
      const model = {}
      if (elForm.jobNo && elForm.jobNo.trim().length > 0) {
        model.jobNo = elForm.jobNo.trim()
      }
      if (elForm.mbl && elForm.mbl.trim().length > 0) {
        model.mbl = elForm.mbl.trim()
      }
      if (elForm.vessel && elForm.vessel.trim().length > 0) {
        model.vessel = elForm.vessel.trim()
      } else if (job && job.vessel && this.params.useDefaultCondition && defaultConditionByDocType) {
        model.vessel = job.vessel
      }
      if (elForm.voyageFlight && elForm.voyageFlight.trim().length > 0) {
        model.voyageFlight = elForm.voyageFlight.trim()
      }
      if (elForm.voyageFlight !== null && elForm.voyageFlight.trim().length > 0) {
        model.voyageFlight = elForm.voyageFlight.trim()
        if (!defaultConditionByDocType) {
          model.voyage = elForm.voyageFlight.trim()
        }
      }
      if (elForm.customerId) {
        model.customerId = elForm.customerId
      }
      if (elForm.carrierId) {
        model.carrierId = elForm.carrierId
      }
      if (elForm.dischargingPortCode && elForm.dischargingPortCode.trim() !== '') {
        model.dischargingPortCode = elForm.dischargingPortCode.trim()
      } else if (job && job.vessel && this.params.useDefaultCondition && defaultConditionByDocType) {
        model.dischargingPortCode = job.dischargingPortCode
      }
      if (job && job.loadingPortCode && defaultConditionByDocType && this.params.useDefaultCondition) {
        model.loadingPortCode = job.loadingPortCode
      }
      if (job && job.destinationAgent && defaultConditionByDocType && this.params.useDefaultCondition) {
        model.destinationAgent = job.destinationAgent
      }
      if (elForm.dfETD1) {
        model.etdStart = elForm.dfETD1
      }
      if (elForm.dfETD2) {
        model.etdEnd = elForm.dfETD2
      }
      if (!elForm.dfETD1 && !elForm.dfETD2 && job && defaultConditionByDocType && this.params.useDefaultCondition) {
        model.etdStart = job.ETD
        model.etdEnd = job.ETD
      }
      model.opDepartment = job ? job.opDepartment : 0
      model.notEqPAgentAndFAgent = elForm.notEqPAgentAndFAgent
      return model
    }
  }
}
</script>

<style lang="scss">
.edi-bill-search-selector {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
}
</style>
